<template>
  <div class="nd-widget-content pull-right">
    <div class="row-fluid">
      <button class="btn btn-secondary" :class="getButtonClass()" title="Publish trackers configuration" @click="publishConfig" :disabled="isButtonDisabled">
        <i class="icon-alt icon-upload"></i>
        Publish configuration
      </button>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import LoadingAnimation from '~/windowEvents/LoadingAnimation';
import Notify from '~/widgets/Notify';
import PublishButtonStatusUpdate from '~/windowEvents/PublishButtonStatusUpdate';
import GroupTrackersConfigApiClient from '~/apiClients/GroupTrackersConfigApiClient';

export default defineComponent({
  name: 'PublishConfigurationButton',
  data() {
    return {
      isButtonDisabled: true as boolean,
    };
  },
  async beforeMount() {
    await this.setButtonStatus();
    window.addEventListener(PublishButtonStatusUpdate.EVENT_TYPE, this.setButtonStatus);
  },
  beforeUnmount() {
    window.removeEventListener(PublishButtonStatusUpdate.EVENT_TYPE, this.setButtonStatus);
  },
  methods: {
    getApiClient() {
      return new GroupTrackersConfigApiClient();
    },

    getButtonClass(): string {
      return 'btn-' + (this.isButtonDisabled ? 'secondary' : 'primary');
    },

    async publishConfig() {
      await LoadingAnimation.perform(async () => {
        return await this.getApiClient().publish()
          .catch(() => {
            throw new Error('Error occurred while publishing the configuration');
          });
      }).then(() => {
        this.isButtonDisabled = true;
        Notify.success('Trackers configuration has been published')
      }).catch((e) => {
        Notify.error(e);
        LoadingAnimation.hide();
      });
    },

    async setButtonStatus() {
      this.isButtonDisabled = await this.getApiClient().getIsPublishedStatus();
    },
  },
});
</script>
